var map = {
	"./template.betprofessor": 1505,
	"./template.betprofessor.tsx": 1505,
	"./template.betroyale": 1506,
	"./template.betroyale.tsx": 1506,
	"./template.default": 665,
	"./template.default.tsx": 665,
	"./template.fiestabet": 1507,
	"./template.fiestabet.tsx": 1507,
	"./template.goldenbet888": 1508,
	"./template.goldenbet888.tsx": 1508,
	"./template.goldrenrush": 1509,
	"./template.goldrenrush.tsx": 1509,
	"./template.puntcity": 1510,
	"./template.puntcity.tsx": 1510,
	"./template.puntgenie": 1511,
	"./template.puntgenie.tsx": 1511,
	"./template.questbet": 1512,
	"./template.questbet.tsx": 1512,
	"./template.sterlingparker": 1513,
	"./template.sterlingparker.tsx": 1513,
	"./template.ts": 979,
	"./template.vikingbet": 1514,
	"./template.vikingbet.tsx": 1514,
	"./template.volcanobet": 1515,
	"./template.volcanobet.tsx": 1515,
	"./template.wellbet": 1516,
	"./template.wellbet.tsx": 1516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2435;